const windowRedirect = ({ url = "", allowPageRedirect = true }) => {
	if (!url) {
		return;
	}
	const redirectWindow = window.open();
	if (allowPageRedirect && !redirectWindow) {
		if (window.parent) {
			window.parent.location.href = url;
			return;
		}
		window.location.href = url;
		return;
	}
	redirectWindow.opener = null;
	redirectWindow.location = url;
};
export default windowRedirect;
